import { Skeleton } from "antd";

import summaryStyle from "./insights-summary.module.css";
import chartStyle from "./score-distribution-chart.module.css";
import style from "./insights-skeleton.module.css";

function SkeletonCard() {
  return (
    <div className={style.skeletonCard} data-testid="skeleton-card">
      <Skeleton active={true} title={{ width: "60%" }} paragraph={{ rows: 1, width: "40%" }} />
    </div>
  );
}

function SkeletonChart() {
  return (
    <div className={style.skeletonChartCard} data-testid="skeleton-chart">
      <Skeleton active={true} title={{ width: "40%" }} paragraph={false} />
      <Skeleton.Node active={true} style={{ width: "100%", height: 200 }} />
    </div>
  );
}

export function InsightsSkeleton() {
  return (
    <div>
      <Skeleton.Input active={true} size="small" style={{ width: 180, marginBottom: 12 }} />
      <div className={summaryStyle.summaryRow}>
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>

      <Skeleton.Input active={true} size="small" style={{ width: 180, marginBottom: 12 }} />
      <div className={chartStyle.competencyGrid}>
        <SkeletonChart />
        <SkeletonChart />
        <SkeletonChart />
        <SkeletonChart />
      </div>
    </div>
  );
}
